import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import StatefulMultiSelect from "@khanacademy/react-multi-select";

export default class DriverAllJobReport extends Component {
    constructor(props) {
        super(props);
        this.state = {
            startDate:moment().toDate(),
            endDate:moment().toDate(),
            isLoading:false,
            getInvoicedReportUrl:'/api/v1/portal/portal-admin/driver-all-job-report',
            InvoicedJobsReportData:[],
            downloadReportName:'Driver All Job Report',
            selectedDrivers:[],
            drivers:[],
            // url: "/api/v1/portal/customers/all/for-dropdown-menu",
            url: "/api/v1/portal/drivers/all/for-dropdown-menu",
        };
        this.handleStartDateChange = this.handleStartDateChange.bind(this);
        this.handleEndDateChange = this.handleEndDateChange.bind(this);
        this.handleCustomerSelection = this.handleCustomerSelection.bind(this);
    }
    componentDidMount() {
        let options = [];   
        return fetch(this.state.url, {
          method: "GET",
          mode: "cors",
          cache: "no-cache",
          credentials: "same-origin",
          headers: {
            "Authorization": 'Bearer ' + window.api_token
            , "Accept": 'application/json'
          },
        }).then((responseText) => {
          let response = responseText.json();
          response.then((response) => {
              response.map((driver)=>{
                options.push({
                    label : driver.company.short_name+'-'+driver.first_name+' '+driver.last_name,
                    value : (driver.driver&&driver.driver.id)?driver.driver.id:''
                });
            });
            this.setState({
              drivers: options,
              isLoading: false
            });
          });
        });
      }
    handleStartDateChange(date) {
        this.setState({startDate: date})
    }
    handleEndDateChange(date) {
        this.setState({endDate: date})
    }
    handleCustomerSelection(selectedDrivers) {
        this.setState({selectedDrivers});
    }
    handleInvoicedJobsReportGeneration(e) {
        this.setState({isLoading: true});
        let url = this.state.getInvoicedReportUrl;
        return fetch(url, {
          method: "POST",
          mode: "cors",
          cache: "no-cache",
          credentials: "same-origin",
          headers: {
            "Authorization": 'Bearer ' + window.api_token
            , "Accept": 'application/json'
          },
          body: JSON.stringify({
            driver_ids: this.state.selectedDrivers,
            start_date:moment(this.state.startDate).format("YYYY-MM-DD"),
            end_date:moment(this.state.endDate).format("YYYY-MM-DD")
          }),
        }).then((responseText) => {
          let response = responseText.json();
          response.then((response) => {
            this.setState({
                InvoicedJobsReportData: response,
                isLoading: false
            })
          });
        });
    }
    download(filename, text) {
        this.setState({isDownloading: true});
        let filenamed = filename+" FROM "+moment(this.state.startDate).format("YYYY-MM-DD")+" TO "+moment(this.state.endDate).format("YYYY-MM-DD")+".csv";
        let textdata = "Job REF,REG/VIN,CUSTOMER,POSTCODE TO,POSTCODE FROM,MILEAGE,JOB PRICE,JOB STATUS,COMPLETED DATE,APPROVED FOR INVOICE,INVOICE DATE\n"+text;
        let element = document.createElement('a');
        element.setAttribute('href','data:text/plain;charset=utf-8,' + encodeURIComponent(textdata));
        element.setAttribute('download', filenamed);
        element.style.display = 'none';
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);
        this.setState({isDownloading: false});
      }
    render() {
        let invoicedJobs = [];
        const {selectedDrivers} = this.state;
        let downloadableCsvDataInvoiced = "";
        if(this.state.InvoicedJobsReportData.length > 0){
            this.state.InvoicedJobsReportData.map((currentJob, index) => {
                let joburl = "/jobs/view/"+currentJob.id;
                invoicedJobs.push(
                    <tr key={index}>
                        <td className="job-ref-font16"><a href={joburl}>{currentJob.id}</a></td>
                        <td>{currentJob.vehicle.registration_number != null ? currentJob.vehicle.registration_number : currentJob.vehicle.vin_number}</td>
                        <td>{currentJob.customer.name}</td>
                        <td>{currentJob.dropoff_address.postcode}</td> 
                        <td>{currentJob.pickup_address.postcode}</td> 
                        <td>{currentJob.distance_in_miles}</td> 
                        <td>&pound;{currentJob.job_price}</td> 
                        <td>{currentJob.status}</td> 
                        <td>{currentJob.driver_completed_date}</td> 
                        <td>{currentJob.approved_for_invoice}</td> 
                        <td>{currentJob.invoice_date}</td> 
                    </tr>
            );
            var pickupAddress = ((currentJob.pickup_address)&&(currentJob.pickup_address.address_line_1))?currentJob.pickup_address.address_line_1:'';
            var dropAddress = ((currentJob.dropoff_address)&&(currentJob.dropoff_address.address_line_1))?currentJob.dropoff_address.address_line_1:'';

            downloadableCsvDataInvoiced = downloadableCsvDataInvoiced +
                                            currentJob.id+','+
                                            (currentJob.vehicle.registration_number != null ? currentJob.vehicle.registration_number : currentJob.vehicle.vin_number)+','+
                                            currentJob.customer.name+','+
                                            currentJob.dropoff_address.postcode+','+
                                            currentJob.pickup_address.postcode+','+
                                            currentJob.distance_in_miles+','+
                                            currentJob.job_price+','+
                                            currentJob.status+','+
                                            currentJob.driver_completed_date+','+
                                            currentJob.approved_for_invoice+','+
                                            currentJob.invoice_date+','+
                                            ''+"\n";
            });
        }else{
            invoicedJobs.push(
                <tr key='no-records'><td colSpan="26" className='text-center'>No Records</td></tr>
            );
        }
        
        return (
            <div className="container-fluid">
                <div className="col-md-6">
                    <h2>Driver All Job Report</h2>
                    <br/>
                </div>
                
                <div className="row">
                    <div className="col-md-1">
                        <label><h5>Select Start Date:</h5></label><br/>
                        <DatePicker todayButton={"Today"} dateFormat="dd/MM/yyyy" onChange={this.handleStartDateChange} selected={this.state.startDate}/>
                    </div>
                    <div className="col-md-1">
                        <label><h5>Select End Date:</h5></label><br/>
                        <DatePicker todayButton={"Today"} dateFormat="dd/MM/yyyy" onChange={this.handleEndDateChange} selected={this.state.endDate}/>
                    </div>
                    <div className="col-md-3 col-sm-12">
                        <label><h5>Select Driver</h5></label><br/>
                            <div>
                                <StatefulMultiSelect
                                    options={this.state.drivers}
                                    selected={selectedDrivers}
                                    onSelectedChanged={this.handleCustomerSelection}
                                        overrideStrings={{
                                            selectSomeItems: "Select Drivers...",
                                            allItemsAreSelected: "All Drivers are Selected",
                                            selectAll: "Select All",
                                            search: "Search Driver",
                                        }}
                                    />
                            </div>
                    </div>
                    <div className="col-md-3">
                        <div className="form-group">
                            <button className="btn btn-lg btn-success invoiced-btn-margin" onClick={(e) => this.handleInvoicedJobsReportGeneration(e)}>
                                   <i className="fa fa-save"></i> Generate Driver All Job Report
                            </button>
                        </div>
                    </div>
                    <div className="col-md-2">
                        <div className="form-group">
                            <button className="btn btn-primary btn-lg invoiced-btn-margin"
                                    onClick={(e) => {
                                    this.download(this.state.downloadReportName, downloadableCsvDataInvoiced);
                                  }}>
                                <i className="fa fa-download"></i> Download Driver All Job Report
                            </button>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-3"><label className="alert alert-primary"><b>{this.state.InvoicedJobsReportData.length} jobs found..</b></label></div>             
                </div>
                <div className="row">
                    <div className="col-md-12 col-sm-12">
                        <div className="daily-delivered-report-tbl-scroll">
                            <table className="daily-delivered-report-tbl">
                                <thead className="sticky-top-without-zindex bg-light">
                                    <tr>
                                        <th>Job Ref</th>
                                        <th>Reg/VIN</th>
                                        <th>Customer</th>
                                        <th>Postcode to</th>
                                        <th>Postcode from</th>
                                        <th>Mileage</th>
                                        <th>Job Price</th>
                                        <th>Job Status</th>
                                        <th>Completed date</th>
                                        <th>Approved for invoice</th>
                                        <th>Invoice date</th>
                                    </tr>
                                </thead>
                                <tbody>
                                {this.state.isLoading ?
                                (<tr><td colSpan="26"><span className="add-loading-text">
                                        <i className="fa fa-spinner fa-pulse"></i></span></td></tr>) :
                                    invoicedJobs
                                }
                                </tbody>
                            </table>
                        </div>
                        <br/><br/><br/>
                    </div>
                </div>
            </div>
        );
    }
}
if (document.getElementById('react-component-g4-logistics-portal-driver_all_job_report')) {
    ReactDOM.render(
        <DriverAllJobReport message_if_none = 'Nothing to report on.' />,
        document.getElementById('react-component-g4-logistics-portal-driver_all_job_report')
    );
}
